// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import API_URL from '../Config';
// import "../css/Sidebar.css";
// import "../App.css"
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2'
// import React, { useState, useEffect, useRef } from 'react';
// import ReactPlayer from 'react-player';

// const ScheduledStream = () => {

//   const [title, setTitle] = useState('');
//   const [scheduledAt, setScheduledAt] = useState('');
//   const [image, setImage] = useState(null);
//   const [imageUrl, setImageUrl] = useState(null); // To display image preview
//   const [video, setVideo] = useState(null);
//   const [videoUrl, setVideoUrl] = useState(null); // To display video preview
//   const [error, setError] = useState('');
//   const token = sessionStorage.getItem("tokenn");

//   // Image handlers
//   const handleDrop = (event) => {
//     event.preventDefault();
//     const file = event.dataTransfer.files[0];
//     handleFile(file);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     handleFile(file);
//   };

//   const handleFile = (file) => {
//     if (file && file.type === 'image/png') {
//       setError('');
//       setImage(file);

//       // Display image preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImageUrl(reader.result);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setError('Only PNG files are accepted.');
//     }
//   };

//   const handleDragOver = (event) => {
//     event.preventDefault();
//   };

//   // Video handlers
//   const handleVideoChange = (event) => {
//     const file = event.target.files[0];
//     if (file && file.type === 'video/mp4') {
//       setError('');
//       setVideo(file);
//       setVideoUrl(URL.createObjectURL(file));
//     } else {
//       setError('Only MP4 video files are accepted.');
//     }
//   };

//   // Submit handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!image) {
//       setError('Please upload an image.');
//       return;
//     }
//     if (!video) {
//       setError('Please upload a video.');
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append('title', title);
//       formData.append('scheduledAt', scheduledAt);
//       formData.append('image', image);
//       formData.append('file', video);

//       const response = await axios.post(`${API_URL}/api/streams/uploadSchedule`, formData, {
//         headers: {
//         //   Authorization: token,
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       console.log(response.data);
//       Swal.fire({
//         title: 'Success!',
//         text: 'Video uploaded successfully.',
//         icon: 'success',
//         confirmButtonText: 'OK',
//       });

//       setTitle('');
//       setScheduledAt('');
//       setImage(null);
//       setImageUrl(null);
//       setVideo(null);
//       setVideoUrl(null);
//       setError('');
//     } catch (error) {
//       console.error('Error uploading video:', error);
//       throw error;
//     }
//   };

//   return (
//     <div className="marquee-container">
//       <div className='AddArea'>
//         {/* <button className='btn btn-custom' onClick={() => handleClick("/admin/addAudio")}>Add Audio</button> */}
//       </div><br />
//       <div className='container3 mt-10'>
//         <ol className="breadcrumb mb-4 d-flex my-0">
//           <li className="breadcrumb-item">
//             <Link to="/admin/Viewcastandcrew">Live Streaming</Link>
//           </li>
//         </ol>

//         <form onSubmit={handleSubmit} method="post">
//           <div className="outer-container">
//             <div className="table-container">
//               <div className="row py-3 my-3 align-items-center w-100">
//                 <div className="col-md-3">
//                   <label className="custom-label">Title</label>
//                 </div>
//                 <div className="col-md-4">
//                   <input
//                     type="text"
//                     id="textbox"
//                     className="form-control border border-dark"
//                     placeholder="Enter your name"
//                     value={title}
//                     onChange={(e) => setTitle(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="row py-3 my-3 align-items-center w-100">
//                 <div className="col-md-3">
//                   <label className="custom-label">scheduledAt</label>
//                 </div>
//                 <div className="col-md-4">
//                   <input
//                     type="text"
//                     id="textbox"
//                     className="form-control border border-dark"
//                     placeholder="Description"
//                     value={scheduledAt}
//                     onChange={(e) => setScheduledAt(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="row py-3 my-3 align-items-center w-100">
//                 {/* Image Upload */}
//                 <div className="col-md-3">
//                   <label className="custom-label">Picture</label>
//                 </div>
//                 <div className="col-md-2 w-100 h-100">
//                   <div
//                     className="drag-drop-area border border-dark text-center"
//                     onDrop={handleDrop}
//                     onDragOver={handleDragOver}
//                     style={{
//                       backgroundSize: 'cover',
//                       backgroundPosition: 'center',
//                     }}
//                   >
//                     {imageUrl ? (
//                       <img src={imageUrl} alt="Preview" style={{ width: '100%', maxHeight: '120px', objectFit: 'contain' }} />
//                     ) : (
//                       <span>Drag and drop</span>
//                     )}
//                   </div>
//                   <div className="col-md-4">
//                     <span style={{ whiteSpace: 'nowrap' }}>please choose png format only*</span>
//                   </div>
//                   <div className="col-md-3">
//                     <span style={{ whiteSpace: 'nowrap' }}>{error && <div className="text-danger">{error}</div>}</span>
//                   </div>
//                 </div>
//                 <div className="col-md-4 mt-3">
//                   <input
//                     type="file"
//                     id="fileInput"
//                     style={{ display: 'none' }}
//                     accept="image/png"
//                     onChange={handleFileChange}
//                   />
//                   <button
//                     type="button"
//                     className="border border-dark mt-4 p-1 bg-silver ml-2"
//                     onClick={() => document.getElementById('fileInput').click()}
//                   >
//                     Choose File
//                   </button>
//                 </div>

//                 {/* Video Upload (next to image) */}
//                 <div className="col-md-3">
//                   <label className="custom-label">Video</label>
//                 </div>
//                 <div className="col-md-2 w-100 h-100">
//                   <div>
//                     {videoUrl ? (
//                       <video width="120" controls src={videoUrl} style={{ maxHeight: '120px' }} />
//                     ) : (
//                       <span>Choose or drag MP4 video</span>
//                     )}
//                   </div>
//                   <div className="col-md-4">
//                     <span style={{ whiteSpace: 'nowrap' }}>please choose mp4 format only*</span>
//                   </div>
//                   <div className="col-md-3">
//                     <span style={{ whiteSpace: 'nowrap' }}>{error && <div className="text-danger">{error}</div>}</span>
//                   </div>
//                 </div>
//                 <div className="col-md-4 mt-3">
//                   <input
//                     type="file"
//                     id="videoInput"
//                     style={{ display: 'none' }}
//                     accept="video/mp4"
//                     onChange={handleVideoChange}
//                   />
//                   <button
//                     type="button"
//                     className="border border-dark mt-4 p-1 bg-silver ml-2"
//                     onClick={() => document.getElementById('videoInput').click()}
//                   >
//                     Choose Video
//                   </button>
//                 </div>
//               </div>

//               <div className="row py-1 my-1 w-100">
//                 <div className="col-md-8 ms-auto text-end">
//                   <button
//                     className="border border-dark p-1.5 w-20 mr-5 text-black me-2 rounded-lg"
//                     type="button"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     className="mt-20 border border-dark p-1.5 w-20 text-white rounded-lg"
//                     type="submit"
//                     style={{ backgroundColor: '#2b2a52' }}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>

//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ScheduledStream;

import axios from 'axios';
import { Link } from 'react-router-dom';
import API_URL from '../Config';
import "../css/Sidebar.css";
import "../App.css"
import Swal from 'sweetalert2'
import React, { useState, useEffect } from 'react';
import { FaPlay, FaEdit, FaTrash } from 'react-icons/fa';

const ScheduledStream = () => {
  const [streams, setStreams] = useState([]);

  // Fetch scheduled streams
  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/streams/getScheduledVideos`); // 🔹 adjust endpoint if needed
        setStreams(response.data);
      } catch (error) {
        console.error("Error fetching streams:", error);
      }
    };
    fetchStreams();
  }, []);

  // Delete stream
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/streams/${id}`);
      setStreams(streams.filter((s) => s.id !== id));
      Swal.fire("Deleted!", "Stream removed successfully", "success");
    } catch (error) {
      console.error("Error deleting stream:", error);
      Swal.fire("Error!", "Could not delete stream", "error");
    }
  };

  return (
    <div className="marquee-container">
      <div className="container3 mt-10">
        <ol className="breadcrumb mb-4 d-flex my-0">
          <li className="breadcrumb-item">
            <Link to="/admin/Viewcastandcrew">Live Streaming</Link>
          </li>
        </ol>

        {/* Streams Table */}
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead style={{ background: "#2b2a52", color: "white" }}>
              <tr>
                <th>ID</th>
                <th>SOURCE</th>
                <th>STREAM NAME</th>
                <th>START TIME</th>
                <th>END TIME</th>
                <th>STATUS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {streams.length > 0 ? (
                streams.map((stream, index) => (
                  <tr key={stream.id}>
                    <td>{index + 1}</td>
                    <td>{stream.uploadType}</td>
                    <td>{stream.streamTitle}</td>
                    <td>{new Date(stream.scheduleStart).toLocaleString()}</td>
                    <td>{new Date(stream.scheduleEnd).toLocaleString()}</td>
                    <td>
                      <span
                      className={`badge ${
                        stream.status === "PUBLISHED"
                          ? "bg-success"
                          : stream.status === "READY"
                          ? "bg-info"
                          : stream.status === "PENDING"
                          ? "bg-warning"
                          : "bg-danger"
                      }`}
                    >
                      {stream.status}
                    </span>

                    </td>
                    <td>
                      <button className="btn btn-sm btn-primary me-2">
                        <FaPlay />
                      </button>
                      <button className="btn btn-sm btn-warning me-2">
                        <FaEdit />
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(stream.id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No streams found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ScheduledStream;